module.exports = __webpack_public_path__ + "img/collectionpage.20eab3d9.svg";